import { ReactNode } from 'react'
import { CardContainer } from './style'

interface ICardProps {
  children: ReactNode
  dataTestId: string
}

export default function ResumeInputCardComponent(props: ICardProps) {
  const { children, dataTestId } = props

  return (
    <CardContainer data-testid={dataTestId}>
      <div className="txtContainer">{children}</div>
    </CardContainer>
  )
}
